import { useEffect } from "react";

const ensureNamedFile = (file) => {
  if (!file) return null;
  if (file.name) return file;
  const ext = file.type && file.type.includes("/")
    ? file.type.split("/")[1]
    : "png";
  return new File([file], `pasted-${Date.now()}.${ext}`, {
    type: file.type || "image/png",
  });
};

const extractFiles = (event, allowedTypes) => {
  const types =
    Array.isArray(allowedTypes) && allowedTypes.length > 0
      ? allowedTypes
      : ["image/"];
  const items = Array.from(event.clipboardData?.items || []);
  const files = items
    .filter((item) => item.kind === "file")
    .map((item) => ensureNamedFile(item.getAsFile()))
    .filter(Boolean)
    .filter((file) =>
      types.some((prefix) => String(file.type || "").startsWith(prefix)),
    );
  return files;
};

const isEditableTarget = (target) => {
  const el = target?.nodeType === 1 ? target : target?.parentElement;
  return Boolean(
    el?.closest?.(
      "input, textarea, [contenteditable=''], [contenteditable='true']",
    ),
  );
};

export const usePasteFiles = ({
  ref,
  disabled,
  onFiles,
  allowedTypes,
  global = false,
}) => {
  useEffect(() => {
    if (disabled) return undefined;
    const handler = (event) => {
      if (global) {
        if (isEditableTarget(event.target)) return;
      } else {
        if (!ref?.current) return;
        if (!ref.current.contains(event.target)) return;
      }
      const files = extractFiles(event, allowedTypes);
      if (files.length === 0) return;
      event.preventDefault();
      onFiles?.(files);
    };
    document.addEventListener("paste", handler);
    return () => document.removeEventListener("paste", handler);
  }, [ref, disabled, onFiles, global]);
};
